import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_yeastInfection_feverChillsPelvicPain',
    label: 'Do you have fever, chills, or pelvic/lower abdominal pain?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_abnormalBleeding',
    label:
      'Is there any abnormal vaginal bleeding or bleeding between periods?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_ulcersSores',
    label:
      'Do you have any ulcers, sores, blisters, or open lesions on the vulva or vagina?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_stiExposure',
    label:
      'Have you recently had unprotected sex with a new or multiple partners, or been exposed to a partner with an STI?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_recurrentYeast',
    label: 'Have you had 4 or more confirmed yeast infections in the past year?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_antifungalNoImprovement',
    label:
      'Have you used an appropriate anti-fungal treatment in the past 2 weeks without improvement?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_severeInterference',
    label:
      'Is the pain, swelling, or irritation severe enough to interfere with sitting, walking, or daily activities?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'Mild interference only', key: 'mild_interference' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_symptoms',
    label: 'What symptoms are you currently experiencing? Select all that apply:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Itching', key: 'itching' },
        { value: 'Burning', key: 'burning' },
        { value: 'Soreness/irritation', key: 'soreness_irritation' },
        { value: 'Pain with urination', key: 'pain_with_urination' },
        { value: 'Pain with intercourse', key: 'pain_with_intercourse' },
        { value: 'Abnormal discharge', key: 'abnormal_discharge' },
        {
          value: 'Other',
          key: 'other',
          answer: {
            type: 'text',
            name: 'zalud_yeastInfection_symptomsOther',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_symptomDuration',
    label: 'How long have you had these symptoms?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Less than 3 days', key: 'less_than_3_days' },
        { value: '3–7 days', key: '3_to_7_days' },
        { value: '1–2 weeks', key: '1_to_2_weeks' },
        { value: 'More than 2 weeks', key: 'more_than_2_weeks' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_dischargeDescription',
    label: 'Would you describe your vaginal discharge?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Thick and white/curd-like', key: 'thick_white_curd_like' },
        { value: 'Thin and watery', key: 'thin_watery' },
        { value: 'Gray', key: 'gray' },
        { value: 'Yellow-green', key: 'yellow_green' },
        { value: 'Frothy', key: 'frothy' },
        { value: 'None', key: 'none' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_dischargeOdor',
    label: 'Does the discharge have an odor?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'None', key: 'none' },
        { value: 'Mild/fishy', key: 'mild_fishy' },
        { value: 'Strong/fishy', key: 'strong_fishy' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_itchingLocation',
    label:
      'Is the itching/irritation located externally (vulva), internally (vagina), or both?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'External only', key: 'external_only' },
        { value: 'Internal only', key: 'internal_only' },
        { value: 'Both', key: 'both' },
        { value: 'None', key: 'none' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_vulvarChanges',
    label:
      'Have you noticed any redness, swelling, cracks, or skin breakdown in the vulvar area?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_menstrualCycleTiming',
    label:
      'When in your menstrual cycle did your symptoms begin or worsen?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Before your period', key: 'before_period' },
        { value: 'During your period', key: 'during_period' },
        { value: 'After your period', key: 'after_period' },
        { value: 'No clear pattern', key: 'no_clear_pattern' },
        { value: 'Not applicable', key: 'not_applicable' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_antibiotics',
    label: 'Have you taken antibiotics in the past 4 weeks?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_diabetes',
    label: 'Do you have diabetes? If yes, is it well-controlled?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No diabetes', key: 'no_diabetes' },
        { value: 'Yes, well-controlled', key: 'yes_well_controlled' },
        { value: 'Yes, poorly controlled', key: 'yes_poorly_controlled' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_newProducts',
    label:
      'Have you started or changed any new soaps, detergents, feminine hygiene products, or contraceptives recently?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_newPartner',
    label:
      'If you are sexually active, have you had a new sexual partner recently?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Sexually active, no new partner',
          key: 'sexually_active_no_new_partner'
        },
        {
          value: 'Sexually active, new partner recently',
          key: 'sexually_active_new_partner'
        },
        {
          value: 'Not currently sexually active',
          key: 'not_sexually_active'
        }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_priorTreatment',
    label:
      'Have you tried any treatment for this already (OTC anti-fungal, prescription)? If so, did it help?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I did not try a treatment yet',
          key: 'did_not_try'
        },
        {
          value: 'Tried OTC anti-fungal and it helped',
          key: 'otc_helped'
        },
        {
          value: 'Tried OTC anti-fungal and it did not help',
          key: 'otc_did_not_help'
        },
        {
          value: 'Tried prescription treatment and it helped',
          key: 'prescription_helped'
        },
        {
          value: 'Tried prescription treatment and it did not help',
          key: 'prescription_did_not_help'
        }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_hormonalContraception',
    label:
      'Are you currently using hormonal contraception, especially a high-estrogen oral contraceptive pill?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No', key: 'no' },
        {
          value: 'Yes, high-estrogen oral contraceptive',
          key: 'yes_high_estrogen_ocp'
        },
        {
          value: 'Yes, other hormonal contraceptive',
          key: 'yes_other_hormonal'
        },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_menstruating',
    label: 'Are you currently menstruating?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        {
          value: 'Expecting my period within the next few days',
          key: 'expecting_period'
        }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_iud',
    label: 'Do you currently have an IUD (intrauterine device)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_confirmedYeast',
    label:
      'Have you ever had a yeast infection confirmed by a healthcare provider, such as by exam, microscopy, or culture?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_postmenopausal',
    label:
      'Are you postmenopausal and experiencing these symptoms for the first time?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes, postmenopausal and first time',
          key: 'postmenopausal_first_time'
        },
        {
          value: 'Yes, postmenopausal but had similar symptoms before',
          key: 'postmenopausal_prior_symptoms'
        },
        { value: 'Not postmenopausal', key: 'not_postmenopausal' }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_yeastInfection_additionalComments'
    }
  },
  {
    field: 'zalud_yeastInfection_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_yeastInfection_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_yeastInfection_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludYeastInfectionQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
